import { jsxs, jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@effektify/theme";
import { useTheme } from "@mui/material/styles";
const DefWrapper = styled("div")(() => ({
  display: "block",
  width: 0,
  height: 0,
  position: "absolute",
  top: 0,
  left: 0
}));
const GradientDefs = () => {
  const $ = c(10);
  const theme = useTheme();
  let t0;
  if ($[0] !== theme.charts.bar.gradients) {
    t0 = Object.entries(theme.charts.bar.gradients).map(_temp);
    $[0] = theme.charts.bar.gradients;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== theme.charts.line.gradients) {
    t1 = Object.entries(theme.charts.line.gradients).map(_temp2);
    $[2] = theme.charts.line.gradients;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== theme.charts.gauge.colors) {
    t2 = Object.entries(theme.charts.gauge.colors).map(_temp3);
    $[4] = theme.charts.gauge.colors;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = /* @__PURE__ */jsx(DefWrapper, {
      children: /* @__PURE__ */jsx("svg", {
        width: "0",
        height: "0",
        children: /* @__PURE__ */jsxs("defs", {
          children: [t0, t1, t2]
        })
      })
    });
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(t0) {
  const [key, gradient] = t0;
  return /* @__PURE__ */jsxs("linearGradient", {
    id: `${key}-bar-gradient`,
    gradientTransform: "rotate(90)",
    children: [/* @__PURE__ */jsx("stop", {
      offset: gradient[0]?.offset,
      stopColor: gradient[0]?.color
    }), /* @__PURE__ */jsx("stop", {
      offset: gradient[1]?.offset,
      stopColor: gradient[1]?.color
    })]
  }, key);
}
function _temp2(t0) {
  const [key_0, gradient_0] = t0;
  return /* @__PURE__ */jsxs("linearGradient", {
    id: `${key_0}-line-gradient`,
    gradientTransform: "rotate(90)",
    gradientUnits: "userSpaceOnUse",
    children: [/* @__PURE__ */jsx("stop", {
      offset: gradient_0[0]?.offset,
      stopColor: gradient_0[0]?.color
    }), /* @__PURE__ */jsx("stop", {
      offset: gradient_0[1]?.offset,
      stopColor: gradient_0[1]?.color
    })]
  }, key_0);
}
function _temp3(t0) {
  const [key_1, colors] = t0;
  return /* @__PURE__ */jsxs("linearGradient", {
    id: `${key_1}-gauge-gradient`,
    children: [/* @__PURE__ */jsx("stop", {
      offset: "0%",
      stopColor: colors[1]
    }), /* @__PURE__ */jsx("stop", {
      offset: "100%",
      stopColor: colors[0]
    })]
  }, key_1);
}
export { GradientDefs as default };